"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarEquipment = void 0;
var react_1 = __importDefault(require("react"));
var CarEquipment_module_scss_1 = __importDefault(require("./CarEquipment.module.scss"));
var react_redux_1 = require("react-redux");
var modalSlice_1 = require("../../redux/slice/modalSlice");
var CarEquipment = function (_a) {
    var car = _a.car;
    var dispath = (0, react_redux_1.useDispatch)();
    var openModalEquipment = function () {
        dispath((0, modalSlice_1.openModal)('equipment'));
    };
    return (react_1.default.createElement("div", { className: CarEquipment_module_scss_1.default.equipment },
        react_1.default.createElement("ul", { className: CarEquipment_module_scss_1.default.equipment__list },
            react_1.default.createElement("li", { className: CarEquipment_module_scss_1.default.equipment__item },
                react_1.default.createElement("span", { className: CarEquipment_module_scss_1.default.equipment__title_equipment }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F"),
                react_1.default.createElement("span", null, car.complectation_name)),
            react_1.default.createElement("li", { className: CarEquipment_module_scss_1.default.equipment__item },
                react_1.default.createElement("span", { className: CarEquipment_module_scss_1.default.equipment__title_review }, "\u041E\u0431\u0437\u043E\u0440"),
                car.extras.slice(0, 1).map(function (category) {
                    return category.names.slice(0, 3).map(function (name) {
                        return react_1.default.createElement("span", { key: name }, name);
                    });
                }))),
        react_1.default.createElement("button", { className: CarEquipment_module_scss_1.default.equipment__button, type: "button", onClick: openModalEquipment }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435")));
};
exports.CarEquipment = CarEquipment;
